import React from 'react';
import { ArrowForwardIos } from '@mui/icons-material';
import { Typography } from '@mui/material';
import ResponsiveImageRender from '../../../common/ResponsiveImageRender';
import useStyles from '../../styles';
import {
  extraSmallMobileStartBreakpoint,
  mobileStartBreakpoint,
  smallMobileStartBreakpoint
} from '@/materialUi/theme';

import { useResponsiveContext } from '@/context/ResponsiveProvider';
import { NationalMenuTileData, ProductImage } from '@/common/pageSetup/categories/nationalMenuData/types';
import { NATIONAL_TILE_ID } from '@/menu/categories/national/constants';

const mobileResolutions = [
  mobileStartBreakpoint,
  smallMobileStartBreakpoint,
  extraSmallMobileStartBreakpoint
];

export interface NationalMenuTileProps extends Omit<NationalMenuTileData, 'desktopImageUrl' | 'mobileImageUrl' | 'priority'> {
  image: ProductImage;
}

const NationalMenuTile = ({
  id, image, name, productDescription, handleClick
}: NationalMenuTileProps): JSX.Element => {
  const classes = useStyles();

  const { initialWidth } = useResponsiveContext() || {};
  // @ts-expect-error - existing code
  const isMobile = mobileResolutions.includes(initialWidth);
  const singleImageStyle = !isMobile && (NATIONAL_TILE_ID.find((cid) => cid === id));

  const fallbackImage = isMobile
    ? '/images/nationalMenu/fallback-product-image-mobile.jpg'
    : '/images/nationalMenu/fallback-product-image-desktop.jpg';

  return (
    <button
      type="button"
      onClick={() => handleClick?.(id)}
      tabIndex={0}
      className={classes.nationalMenuTileContentWrapper}
      data-testid="national-menu-tile"
    >
      <div className={
        singleImageStyle
          ? classes.nationalMenuTileImageWrapper : classes.nationalMenuTileImageWrapperFlex
      }
      >
        <ResponsiveImageRender
          desktop={image.desktop}
          mobile={image.mobile}
          altText={image.altText}
          title={productDescription ?? ''}
          pictureClassName={classes.nationalMenuTilePicture}
          className={
          singleImageStyle
            ? classes.nationalMenuTileImageTransform : classes.nationalMenuTileImage
        }
          testId={`national-menu-tile-image-${id}`}
          fallbackImage={fallbackImage}
          ariaHidden
        />
      </div>
      <div className={classes.nationalMenuTileContent}>
        <Typography variant="h3" className={classes.nationalMenuTileProductName} data-testid="category-name">{name}</Typography>
        {productDescription && (
          <Typography
            className={classes.nationalMenuTileProductDescription}
          >
            {productDescription}
          </Typography>
        )}
      </div>
      <div className={classes.nationalMenuTileCaretIcon}>
        <ArrowForwardIos className={classes.iconRoot} fontSize="inherit" viewBox="0 0 10 24" />
      </div>
    </button>
  );
};

export default NationalMenuTile;
